import React, { useEffect, useState } from "react";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import ReactPaginate from "react-paginate";
import NotFoundData from "../../../../Images/no-data-found.webp";
import BottomMenu from "../../../layout/bottomMenu";
import Calculator from "../../../DistanceCalculator/Calculator";
import {toast} from "react-toastify";
const SmList = ({
  getLead,
  leadList = [],
  match,
  getLeadFilter,
  leadFilter,
  history,
  getjuniorListingForHod,
  juniorListHod = [],
  selfRatingDetails,
  selfListing = [],

}) => {

  const mon =
      {
          1: 'January',
          2: 'February',
          3: 'March',
          4: 'April',
          5: 'May',
          6: 'June',
          7: 'July',
          8: 'August',
          9: 'September',
          10: 'October',
          11: 'November',
          12: 'December'
      };
  const [isLoading, setIsLoading] = useState(false);
  const [filterInputList, setFilterInputList] = useState([{}]);
  const [open, setOpen] = useState(false);
  const [isFilterRemove, setIsRemoveFilter] = useState(false);
  const [pageNo, setPage] = useState(1);
  const [month, setMonth] = useState('');
  const [userId, setUserId] = useState(0)


  useEffect(() => {
    (async () => {
        const today = new Date();
        const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth());
        setUserId(window.localStorage.user_id)
      setIsLoading(true);
      await selfRatingDetails(localStorage.getItem('user_id'));
      setIsLoading(false);
    })();
  }, []);

  const handleFilter = async (key, value, stringValue = "") => {
    const list = [...filterInputList];
    list[0][key] = value;
    setFilterInputList(list);
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getjuniorListingForHod(val?.selected + 1);
    setIsLoading(false);
  };

    const handleSubmitFilter = async () => {
      setOpen(false);
      setIsLoading(true);
      await selfRatingDetails(localStorage.getItem('user_id'), filterInputList);
      setIsLoading(false);
    };

    const handleRemoveFilter = async (key) => {
      if (key !== "") {
        delete filterInputList[0][key];
        setFilterInputList(filterInputList);
        setIsLoading(true);
        await selfRatingDetails(localStorage.getItem('user_id'), filterInputList);
        setIsLoading(false);
      }
    };

    useEffect(() => {
      (async () => {
        if (isFilterRemove) {
          setFilterInputList([{}]);
          setIsLoading(true);
          await selfRatingDetails(localStorage.getItem('user_id'));
          setIsLoading(false);
          setIsRemoveFilter(false);
        }
      })();
    }, [isFilterRemove]);




  return (
    <>
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Self Scorecard"} history={history} />
            <div className="container-fluid common-bg">
              <div className="container-fluid bootstrap snippets bg-white">

                <div className="d-sm-flex align-items-center justify-content-between">

                  <div className="row col-md-12">
                      <button
                        onClick={() => setOpen(!open)}
                        className="btn btn-sm btn-primary mr-1 btn-filter mt-2"
                        type="button"
                      >
                        <i className="fa fa-filter lh-35 pd-3"></i>
                      </button>
                  </div>
                </div>

                {/* Filter View */}
                {filterInputList[0] !== undefined &&
                  Object.keys(filterInputList[0]).length > 0 && (
                    <div className="d-sm-flex align-items-center justify-content-between mt-15">
                      <div className="row pd-filter-div">
                        <div className="col-md-12 col-sm-12 d-flex">
                          <div className="applied-filter">
                            {Object.keys(filterInputList[0]).map((val, i) => {
                              return (
                                <>
                                  <span className="fd-1">
                                    <span
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {val.replaceAll("_", " ")}
                                    </span>
                                    {val.replaceAll("_", " ") === "month" ? " - " + mon[filterInputList[0][val]]: " - "+filterInputList[0][val]}
                                    <i
                                      className="bi bi-x-circle"
                                        onClick={(e) => {
                                          handleRemoveFilter(val);
                                        }
                                      }
                                    ></i>
                                  </span>
                                </>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                {/* Filter View End*/}

                <div className="row mt-5">
                  {/*CARD START*/}
                  {selfListing &&
                    selfListing?.intermediate_senior !== undefined && (
                      <>
                        <div className="col-md-4 col-sm-6 mt-6">
                          <div className="card-big-shadow">
                            <div
                              className="card card-just-text"
                              data-background=""
                              data-color=""
                              data-radius="none"
                            >
                              <div className="content">
                                <h6 className="category mrg-b-12">
                                  <div className="row">
                                    <div
                                      className="col-10"
                                      style={{
                                        color: "#000",
                                        fontSize: "20px",
                                        textAlign: "left",
                                        paddingLeft: "20px",
                                      }}
                                    >
                                    <span className="">
                                      {filterInputList[0] !== undefined && Object.keys(filterInputList[0]).length > 0 ? (
                                        <>
                                          {"Rating by Reporting Manager ( "}
                                          {new Date(filterInputList[0]?.start_date).toLocaleDateString('en-GB')}
                                          {" to "}
                                          {new Date(filterInputList[0]?.end_date).toLocaleDateString('en-GB')}
                                          {" )"}
                                        </>
                                      ) : (
                                        "Rating by Reporting Manager for this month"
                                      )}
                                    </span>

                                    </div>
                                  </div>
                                  <div className="row list-view mt-4">
                                    {selfListing?.intermediate_senior
                                      ?.total_meeting !== null && (
                                      <div className="mb-flex">
                                        <div className="col-md-6 col-sm-6 no-wrap">
                                          <i
                                            className="fa fa-briefcase"
                                            style={{'color': "#770080"}}
                                            aria-hidden="true"
                                          ></i>
                                          &nbsp;&nbsp;No. of meeting done:
                                        </div>
                                        <div className="col-md-6 col-sm-6 l2">
                                          <span
                                            className="trigger float-right mr-1"
                                            data-tooltip-id="1"
                                            title={
                                              selfListing?.intermediate_senior
                                                ?.total_meeting
                                            }
                                          >
                                            {
                                              selfListing?.intermediate_senior
                                                ?.total_meeting
                                            }
                                              <a href={`sm-view/${userId}/2`}><i className="fa fa-eye ml-1" aria-hidden="true"></i></a>
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                    {selfListing?.intermediate_senior
                                      ?.total_meeting_rated !== null && (
                                      <div className="mb-flex mt-2">
                                        <div className="col-md-6 col-sm-6 no-wrap">
                                          <i
                                            className="fa fa-business-time"
                                            style={{'color': "green"}}
                                            aria-hidden="true"
                                          ></i>
                                          &nbsp;&nbsp;No. of meeting rated:
                                        </div>
                                        <div className="col-md-6 col-sm-6 l2">
                                          <span
                                            className="trigger float-right mr-1"
                                            data-tooltip-id="1"
                                            title={
                                              selfListing?.intermediate_senior
                                                ?.total_meeting_rated
                                            }
                                          >
                                            {
                                              selfListing?.intermediate_senior
                                                ?.total_meeting_rated
                                            }
                                              <a href={`sm-view/${userId}/1`}><i className="fa fa-eye ml-1" aria-hidden="true"></i></a>
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                    {selfListing?.intermediate_senior
                                      ?.total_meeting_average_score !==
                                      null && (
                                      <div className="mb-flex mt-2">
                                        <div className="col-md-6 col-sm-6 no-wrap">
                                          <i
                                            className="fa fa-table"
                                            style={{'color': "#1325a8"}}
                                            aria-hidden="true"
                                          ></i>
                                          &nbsp;&nbsp;Average score:
                                        </div>
                                        <div className="col-md-6 col-sm-6 l2">
                                          <span
                                            className="trigger float-right mr-4"
                                            data-tooltip-id="1"
                                            title={
                                              selfListing?.intermediate_senior
                                                ?.total_meeting_average_score
                                            }
                                          >
                                            {
                                              selfListing?.intermediate_senior
                                                ?.total_meeting_average_score
                                            }
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                    {selfListing?.intermediate_senior
                                      ?.last_30_days_average_score !== null && (
                                      <div className="mb-flex mt-2">
                                        <div className="col-md-6 col-sm-6 no-wrap">
                                          <i
                                            className="fas fa-thumbtack"
                                            style={{'color': "#c4a715"}}
                                            aria-hidden="true"
                                          ></i>
                                          &nbsp;&nbsp;Last 30 days avg. score:
                                        </div>
                                        <div className="col-md-6 col-sm-6 l2">
                                          <span
                                            className="trigger float-right mr-4"
                                            data-tooltip-id="1"
                                            title={
                                              selfListing?.intermediate_senior
                                                ?.last_30_days_average_score
                                            }
                                          >
                                            {
                                              selfListing?.intermediate_senior
                                                ?.last_30_days_average_score
                                            }
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                    {selfListing?.intermediate_senior
                                      ?.best_performance !== null && (
                                      <div className="mb-flex mt-2">
                                        <div className="col-md-6 col-sm-6 no-wrap">
                                          <i
                                            className="fa fa-child"
                                            style={{'color': "#e44c18"}}
                                            aria-hidden="true"
                                          ></i>
                                          &nbsp;&nbsp;Highest performer:
                                        </div>
                                        <div className="col-md-6 col-sm-6 l2">
                                          <span
                                            className="trigger float-right mr-4"
                                            data-tooltip-id="1"
                                            title={
                                              selfListing?.intermediate_senior
                                                ?.best_performance
                                            }
                                          >
                                            {
                                              selfListing?.intermediate_senior
                                                ?.best_performance
                                            }
                                          </span>
                                        </div>
                                      </div>
                                    )}

                                    {selfListing?.intermediate_senior
                                      ?.best_performance_score !== null && (
                                      <div className="mb-flex mt-2">
                                        <div className="col-md-6 col-sm-6 no-wrap">
                                          <i
                                            className="fas fa-wallet"
                                            style={{'color': "#802400"}}
                                            aria-hidden="true"
                                          ></i>
                                          &nbsp;&nbsp;Highest avg score:
                                        </div>
                                        <div className="col-md-6 col-sm-6 l2">
                                          <span
                                            className="trigger float-right mr-4"
                                            data-tooltip-id="1"
                                            title={
                                              selfListing?.intermediate_senior
                                                ?.best_performance_score
                                            }
                                          >
                                            {
                                              selfListing?.intermediate_senior
                                                ?.best_performance_score
                                            }
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <hr />
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                  {selfListing && selfListing?.hod !== undefined && (
                    <>
                      <div className="col-md-4 col-sm-6 mt-6">
                        <div className="card-big-shadow">
                          <div
                            className="card card-just-text"
                            data-background=""
                            data-color=""
                            data-radius="none"
                          >
                            <div className="content">
                              <h6 className="category mrg-b-12">
                                <div className="row">
                                  <div
                                    className="col-10"
                                    style={{
                                      color: "#000",
                                      fontSize: "20px",
                                      textAlign: "left",
                                      paddingLeft: "20px",
                                    }}
                                  >
                                    <span className="">{"Rating by HOD"}</span>
                                  </div>
                                </div>
                                <div className="row list-view mt-4">
                                  {/* {selfListing?.hod?.total_meeting !== null && (
                                    <div className="mb-flex">
                                      <div className="col-md-6 col-sm-6 no-wrap">
                                        <i
                                          className="fa fa-briefcase"
                                          aria-hidden="true"
                                        ></i>
                                        &nbsp;&nbsp;No. of meeting done:
                                      </div>
                                      <div className="col-md-6 col-sm-6 l2">
                                        <span
                                          className="trigger"
                                          data-tooltip-id="1"
                                          title={
                                            selfListing?.hod?.total_meeting
                                          }
                                        >
                                          {selfListing?.hod?.total_meeting}
                                        </span>
                                      </div>
                                    </div>
                                  )} */}
                                  {selfListing?.hod
                                    ?.scope_of_hod !== null && (
                                    <div className="mb-flex mt-2">
                                      <div className="col-md-6 col-sm-6 no-wrap">
                                        <i
                                          className="fa fa-business-time"
                                          style={{'color': "green"}}
                                          aria-hidden="true"
                                        ></i>
                                        &nbsp;&nbsp;Score by HOD:
                                      </div>
                                      <div className="col-md-6 col-sm-6 l2">
                                        <span
                                          className="trigger float-right mr-4"
                                          data-tooltip-id="1"
                                          title={
                                            selfListing?.hod
                                              ?.scope_of_hod
                                          }
                                        >
                                          {
                                            selfListing?.hod
                                              ?.scope_of_hod
                                          }
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                  {selfListing?.hod
                                    ?.last_month_rating !== null && (
                                    <div className="mb-flex mt-2">
                                      <div className="col-md-6 col-sm-6 no-wrap">
                                        <i
                                          className="fa fa-table"
                                          style={{'color': "#1325a8"}}
                                          aria-hidden="true"
                                        ></i>
                                        &nbsp;&nbsp;Last month score:
                                      </div>
                                      <div className="col-md-6 col-sm-6 l2">
                                        <span
                                          className="trigger float-right mr-4"
                                          data-tooltip-id="1"
                                          title={
                                            selfListing?.hod
                                              ?.last_month_rating
                                          }
                                        >
                                          {
                                            selfListing?.hod
                                              ?.last_month_rating ?? 0
                                          }
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                  {selfListing?.hod?.feedback !== null && (
                                    <div className="mb-flex mt-2">
                                      <div className="col-md-6 col-sm-6 no-wrap">
                                        <i
                                          className="fas fa-thumbtack"
                                          style={{'color': "#c4a715"}}
                                          aria-hidden="true"
                                        ></i>
                                        &nbsp;&nbsp;HOD feedback:
                                      </div>
                                      <div className="col-md-6 col-sm-6 l2">
                                        <span
                                          className="trigger float-right mr-4"
                                          data-tooltip-id="1"
                                          title={
                                            selfListing?.intermediate_senior
                                              ?.feedback
                                          }
                                        >
                                          {selfListing?.hod?.feedback}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                  {selfListing?.hod?.best_performance !==
                                    null && (
                                    <div className="mb-flex mt-2">
                                      <div className="col-md-6 col-sm-6 no-wrap">
                                        <i
                                          className="fa fa-child"
                                          style={{'color': "#e44c18"}}
                                          aria-hidden="true"
                                        ></i>
                                        &nbsp;&nbsp;Highest performer:
                                      </div>
                                      <div className="col-md-6 col-sm-6 l2">
                                        <span
                                          className="trigger float-right mr-4"
                                          data-tooltip-id="1"
                                          title={
                                            selfListing?.hod?.best_performance
                                          }
                                        >
                                          {selfListing?.hod?.best_performance}
                                        </span>
                                      </div>
                                    </div>
                                  )}

                                  {selfListing?.hod?.best_performance_score !==
                                    null && (
                                    <div className="mb-flex mt-2">
                                      <div className="col-md-6 col-sm-6 no-wrap">
                                        <i
                                          className="fas fa-wallet"
                                          style={{'color': "#802400"}}
                                          aria-hidden="true"
                                        ></i>
                                        &nbsp;&nbsp;Highest score:
                                      </div>
                                      <div className="col-md-6 col-sm-6 l2">
                                        <span
                                          className="trigger float-right mr-4"
                                          data-tooltip-id="1"
                                          title={
                                            selfListing?.hod
                                              ?.best_performance_score
                                          }
                                        >
                                          {
                                            selfListing?.hod
                                              ?.best_performance_score
                                          }
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <hr />
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {selfListing &&
                    juniorListHod?.hod !== undefined &&
                    juniorListHod?.hod?.data?.length === 0 && (
                      <>
                        <img
                          src={NotFoundData}
                          className="not-found-data"
                          alt={""}
                        />
                        <div className="text-center" style={{ width: "100%" }}>
                          Data Not Found
                        </div>
                        
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <BottomMenu
          open={open}
          setOpen={setOpen}
          handleSubmitFilter={handleSubmitFilter}
          filterContent={{data:[
            {'field' : 'dropdown', 'place_holder' : 'Filter For', 'values' : [{'id' : "Reporting Manager", 'name' : 'Reporting Manager'}, {'id' : "HOD", 'name' : 'HOD'}]},
            {'field' : 'dropdown', 'place_holder' : 'Month', 'values' : [
                {'id' : 1, 'name' : 'Jan'},
                {'id' : 2, 'name' : 'Feb'},
                {'id' : 3, 'name' : 'March'},
                {'id' : 4, 'name' : 'April'},
                {'id' : 5, 'name' : 'May'},
                {'id' : 6, 'name' : 'June'},
                {'id' : 7, 'name' : 'July'},
                {'id' : 8, 'name' : 'Aug'},
                {'id' : 9, 'name' : 'Sept'},
                {'id' : 10, 'name' : 'Oct'},
                {'id' : 11, 'name' : 'Nov'},
                {'id' : 12, 'name' : 'Dec'},
              ]},
            {'field' :'text', 'place_holder' : 'Year', 'values' : ''},
            {'field' :'date', 'place_holder' : 'Start Date', 'values' : ''},
            {'field' :'date', 'place_holder' : 'End Date', 'values' : ''},
        ]}}
          handleFilter={handleFilter}
          setIsRemoveFilter={setIsRemoveFilter}
        />
      </div>
      {/* section ends */}
    </>
  );
};

export default SmList;
